import { IconHourglass, IconSeal } from '../../../common/icons';
import { AUTHORIZED, UNAUTHORIZED, authorizationOf } from '../utils/authorization';

import '../styles/authorization-badge.css';

// Authorized or not, drawn the same on the board and in the list: a seal for a
// signed task, an hourglass for one that is still waiting for a person. The
// word is always there; the icon and the colour only reinforce it.
//
// Nothing is drawn when the row cannot tell (a discarded task): a wrong badge
// is worse than none.

const TEXT = {
    [AUTHORIZED]: 'Autorizada',
    [UNAUTHORIZED]: 'Sin autorizar',
};

const HINT = {
    [AUTHORIZED]: 'Pasó por autorización: la cola la puede entregar',
    [UNAUTHORIZED]: 'Propuesta: la cola no la entrega hasta que una persona la autorice',
};

export default function AuthorizationBadge({ workflowState, compact = false }) {
    const status = authorizationOf(workflowState);
    if (!status) return null;

    return (
        <span className={`auth-badge auth-badge--${status}`} title={HINT[status]}>
            {status === AUTHORIZED ? <IconSeal /> : <IconHourglass />}
            <span className={compact ? 'visually-hidden' : 'auth-badge__text'}>{TEXT[status]}</span>
        </span>
    );
}
